<template>
  <div class="container-fluid navbar-container" :class="{ 'scrolled': isScrolled }">
    <nav class="blog-navigation container px-0" >
      <div class="container px-0">
        <div class="nav-content px-0">
          <!-- Logo/Brand -->
          <router-link to="/" class="brand-link">
            <img 
              src="@/assets/images/placeholder-logo.svg" 
              alt="Logo" 
              class="brand-logo"
            >
          </router-link>
  
          <!-- Back to Home Button -->
          <router-link to="/" class="btn btn-primary">
            <i class="fas fa-store me-2"></i>
            <span>Volver a la tienda</span>
          </router-link>
        </div>
      </div>
    </nav>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const isScrolled = ref(false)

const handleScroll = () => {
  isScrolled.value = window.scrollY > 50
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
.navbar-container {
  background-color: var(--black-color);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  z-index: 1000;
}

.nav-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1rem;
}

.blog-navigation {
  background-color: transparent !important;
}

.brand-link {
  text-decoration: none;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
}

.brand-link:hover {
  opacity: 0.8;
  transform: scale(1.05);
}

.brand-logo {
  height: 70px;
  width: auto;
  transition: all 0.3s ease;
}

.scrolled .brand-logo {
  height: 65px;
}
.navbar-container.scrolled {
  background-color: var(--black-color);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  margin-top: 0 !important;
  transition: .3s all;
}
.back-home-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.back-home-btn:hover::before {
  left: 100%;
}

.back-home-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 107, 53, 0.4);
  color: white;
  text-decoration: none;
}

.back-home-btn i {
  font-size: 0.8rem;
  transition: transform 0.3s ease;
  position: relative;
  z-index: 1;
}

.back-home-btn:hover i {
  transform: translateX(-3px);
}

.btn-text {
  position: relative;
  z-index: 1;
}

.scrolled .back-home-btn {
  padding: 0.6rem 1.3rem;
  font-size: 0.85rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .nav-content {
    padding: 0 0.5rem;
  }
  
  .brand-logo {
    height: 55px;
  }
  
  .scrolled .brand-logo {
    height: 30px;
  }
  
  .back-home-btn {
    padding: 0.6rem 1.2rem;
    font-size: 0.85rem;
  }
  
  .scrolled .back-home-btn {
    padding: 0.5rem 1.1rem;
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .blog-navigation {
    padding: 0.75rem 0;
  }
  
  .scrolled .blog-navigation {
    padding: 0.5rem 0;
  }
  
  .brand-logo {
    height: 60px;
  }
  
  .scrolled .brand-logo {
    height: 55px;
  }
  
  .back-home-btn {
    padding: 0.5rem 1rem;
    font-size: 0.8rem;
  }
  
  .scrolled .back-home-btn {
    padding: 0.4rem 0.9rem;
    font-size: 0.75rem;
  }
  
  .btn-text {
    display: none;
  }
  
  .back-home-btn i {
    margin-right: 0;
  }
}
</style> 